import 'bootstrap/dist/css/bootstrap.min.css';
import './TestForm.css';
import Form from "@rjsf/mui";
import validator from "@rjsf/validator-ajv6";
import axios from "axios";
import * as React from "react";
import { useEffect } from "react";
import { configData } from "./configData/configData";
import { useParams } from "react-router-dom"; 


axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;

function FormRisposta(props) {
    const componentRef = React.useRef(null);
    const [formData, setFormData] = React.useState({});
    const { formId } = useParams();  

    useEffect(() => {
        const token = localStorage.getItem('token');
        
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            axios.get(`${configData.API_BASE}/api/forms/submit/dettagli/${formId}/${localStorage.getItem('id')}`)
                .then(res => {
                    const post = res.data;
                    setFormData(post);
                })
                .catch(error => {
                    if ((error.response && error.response.status === 401) || error.response.status === 403 ) {
                        localStorage.removeItem('token');
                        localStorage.removeItem('id');
                        alert("Sessione scaduta. Effettua nuovamente l'accesso.");
                        window.location.href = configData.SITE_URL + "/login";
                    } else {
                        console.error("Errore nel recupero dei dettagli del form:", error);
                        alert("Errore nel caricamento dei dati del form.");
                    }
                });            
        } else {
            axios.defaults.headers.common['Authorization'] = null;
            alert("Utente non autenticato. Effettua l'accesso.");
            window.location.href = configData.SITE_URL + "/login";
        }
    }, [formId]); 

    const modifiedSchema = JSON.parse(JSON.stringify(props.schema));
/* 
    const consensoObj = modifiedSchema.properties?.consensoPresaVisione;
    const checkbox = consensoObj?.properties?.consensoPresaVisioneAccettata;

    if (checkbox) {
        checkbox.title = "Presa Visione, Dichiaro di aver preso visione dell’informativa relativa al trattamento denominato: 'Progetti di mobilità transnazionale, tirocini formativi, formazione sul campo (WBL) e inserimento lavorativo'. Per leggere l'informativa completa, visitare: https://www.euroformrfs.it/it/privacy-it/";
    } */

    const modifiedUiSchema = { ...props.uiSchema };

    if (!modifiedUiSchema.consensoPresaVisione) {
        modifiedUiSchema.consensoPresaVisione = {};
    }

    modifiedUiSchema.consensoPresaVisione.consensoPresaVisioneAccettata = {
        ...modifiedUiSchema.consensoPresaVisione.consensoPresaVisioneAccettata,
        "ui:widget": "checkbox",
        "ui:description": (
            <div style={{ marginTop: "-0.5rem" }}>
                <a
                    href="https://www.euroformrfs.it/wp-content/uploads/2019/06/Informativa-Mobilit%C3%A0-Euroform.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                        textDecoration: "none", 
                        color: "#98989B", 
                        fontWeight: "bold", 
                        fontSize: "0.9rem", 
                        marginLeft: "2rem" 
                    }}
                >
                    Leggi l'informativa completa
                </a>
            </div>
        )
    };
    


    return (
        <div>
            <Form
                schema={modifiedSchema} 
                uiSchema={modifiedUiSchema}
                formData={formData}  
                validator={validator}
                showErrorList={false}
                disabled={true}
                readonly
            />
        </div>
    );
    
}

export default FormRisposta;
